<template>
  <div class="mian_view">
    <div class="hader">
      <h3>{{ stuInfo.realName }}的做题记录</h3>
      <el-button type="primary" @click="toReturn">返回</el-button>
    </div>
    <p>
      考生账号：<span>{{ stuInfo.userName }}</span
      >科室：<span>{{ stuInfo.departmentName }}</span
      >职称：<span>{{ stuInfo.ptitle }}</span
      >做题次数：<span>{{ stuInfo.doExerCiseCount }}</span>
    </p>
    <!-- 表格 -->
    <div class="mian_table" v-loading="loading">
      <el-table :data="recordData" border style="width: 1000px">
        <el-table-column label="序号" type="index" width="60" align="center">
        </el-table-column>
        <el-table-column
          v-for="(item, index) in recordForm"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { recordForm } from "@/state/practiceModel";
import loginvuex from "@/store/index";
import $examApi from "@/api/examApi.js";

export default {
  data() {
    return {
      recordForm: [],
      recordData: [],
      pageIndex: 1, // 起始页
      eachPageNum: 10, // 一页多少条数据
      total: 100,
      loading: false,
      pagesun: "", // 一共多少页
      pagesizesarr: [5, 10, 20, 50, 100],
      stuInfo: {},
    };
  },
  props: ["cutcoms"],
  methods: {
    //返回
    toReturn() {
      this.cutcoms(1);
      this.$destroy();
    },
    // 表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    async getDatalist() {
      let parmars = {
        logID: this.$parent.towCurrentLine.logID, // 试卷ID
        userID: JSON.parse(loginvuex.state.userlist).userID, // 用户ID
        guid: JSON.parse(loginvuex.state.userlist).guid, // token
      };
      const data = await $examApi.stuLogDetail(parmars);
      if (data.status == 200) {
        this.stuInfo = data.data.Data.stuInfo;
        this.recordData = data.data.Data.list.map((item) => {
          this.$set(
            item,
            "completeTime1",
            this.$moment(item.completeTime).format("YYYY/MM/DD HH:mm")
          );
          this.$set(item, "rightRate1", item.rightRate + "%");
          this.$set(item, "doneNum1", item.doneNum + "/" + item.totalNum);
          return item;
        });
      } else {
        this.$message.error(data.statusText);
      }
    },
  },
  created() {
    this.recordForm = recordForm;
    this.getDatalist();
  },
};
</script>

<style lang="scss" scoped>
.mian_view {
  width: 100%;
  padding: 24px;
  min-height: 780px;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
  .hader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-button {
      width: 92px;
      margin-right: 24px;
    }
  }
  h3 {
    letter-spacing: 2px;
  }
  p {
    span {
      display: inline-block;
      margin-right: 22px;
      margin-top: 20px;
    }
  }
}
.mian_table {
  background: #ffffffff;
  // height: 700px;
  margin-top: 24px;
  .add_btn {
    width: 96px;
    height: 40px;
    background: #1890ff;
    opacity: 1;
    border-radius: 4px;
    color: #ffffff;
    margin-bottom: 14px;
  }

  ::v-deep .el-table th:nth-child(1) {
    opacity: 1;
    border-radius: 4px 0px 0px 4px;
  }
  ::v-deep .el-table th:nth-child(13) {
    opacity: 1;
    border-radius: 0px 4px 4px 0px;
  }
  ::v-deep .el-table th > .cell {
    align-items: center !important;
    text-align: center;
  }
  ::v-deep .el-table td > .cell {
    align-items: center !important;
    text-align: center;
  }
  .operation_box {
    ::v-deep .el-button--text {
      font-size: 16px;
      color: #1890ff;
      font-weight: 400;
      &:nth-child(3) {
        color: #ff4747;
      }
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f9f9f9 !important;
}
// 分页
.foot_box {
  position: relative;
  height: 140px;
  ::v-deep .el-pager li:hover {
    color: #1890ff;
  }
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #1890ff;
        border: none;
      }
    }
  }
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
  letter-spacing: 1px;
  color: #2c3e50;
  font-size: 14px;
}
::v-deep .el-table td > .cell {
  align-items: center !important;
  text-align: center;
  letter-spacing: 2px;
  color: #2c3e50;
}
</style>
